const emailRegEx =
  // eslint-disable-next-line max-len
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,63}))$/;

/**
 * Check if the given string is an email address.
 * @param emailAddress
 */
export const checkIsEmailAddress = (emailAddress: string): boolean => {
  const regex = new RegExp(emailRegEx);
  return regex.test(emailAddress);
};
